import { capitalise, getFlattenContentPages, getValidClassNames } from "@/utils";
import { StepNavigationMenuItemProps } from "./StepNavigation.interfaces";
import Link from "next/link";
import { useEffect, useState } from "react";
import { IconCaretDown } from "../Icons";
import { isMenuItemDisabled } from "./StepNavigation.helpers";

export const StepNavigationMenuItem = ({ baseUrl, contentPages, contentPageChildren, currentPageId, id, isDisabled, onItemSelect, title, url }: StepNavigationMenuItemProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  useEffect(() => {
    setIsOpen(contentPageChildren.some(({ id }) => id === currentPageId))
  }, [contentPageChildren, currentPageId]);

  return(
    <li 
      key={id} 
      className={getValidClassNames({
        'flex flex-col m-0 mb-1': true,
        'cursor-not-allowed': Boolean(isDisabled)
      })}
    >
      <div 
        className={getValidClassNames({
          "flex items-center bg-white rounded transition-150": true,
          'bg-grey-300': id === currentPageId,
          'hover:bg-grey-300': !isDisabled
        })}
      >
        {contentPageChildren.length > 0 && (
          <div className="p-2">
            <button 
              aria-expanded={isOpen}
              className={getValidClassNames({
                "flex items-center h-4 w-4 justify-center color-white border-none p-0 rounded-circle pointer transition-150": true,
                "bg-grey-500 hover:bg-black": !isOpen,
                "bg-black rotate-180": isOpen,
              })} 
              onClick={() => setIsOpen(!isOpen)}
            >
              <span className='sr-only'>{`${isOpen ? 'Close' : 'Open'} submenu`}</span>
              <IconCaretDown />
            </button>
          </div>
        )}

        <Link 
          aria-disabled={isDisabled}
          className={getValidClassNames({
            'text-sm flex-1 p-2 text-decoration-none': true,
            'events-none color-grey-600': Boolean(isDisabled),
            'color-black': !isDisabled

          })} 
          href={`${baseUrl}/${url}`}
          onClick={() => {
            if(onItemSelect) {
              onItemSelect(id)
            }
          }}
        >
          {capitalise(title)}
        </Link>
      </div>

      {contentPageChildren.length > 0 && isOpen && (
        <ol className="list-style-none ml-6 flex flex-col mb-1 mt-1">
          {contentPageChildren.map(({ contentPageChildren, id, title, url }) => {
            return(
              <StepNavigationMenuItem
                key={id}
                baseUrl={baseUrl}
                contentPages={contentPages}
                contentPageChildren={contentPageChildren}
                currentPageId={currentPageId}
                id={id}
                title={title}
                url={url}
                isDisabled={isMenuItemDisabled(id, currentPageId, contentPages)}
                onItemSelect={onItemSelect}
              />
            )
          })}
        </ol>
      )}
    </li>
  )
};